import { useContext } from 'react';
import { AppAlertsContext } from '../../contexts/AppAlertsProvider';

export const useAppAlerts = () => {
    return useContext(AppAlertsContext);
};
